import * as zod from 'zod';

// Add supported teleop modes here
// Also update TELEOP_MODE_LABELS in libs/remote-control/step/teleop.ts
// Also update EXPECTED_CLIENT_TYPE in Step/Teleop/Step.ts
export const TeleopModeEnum = zod.enum([
  'arHeadset',
  'iosPhone',
  'iosTablet',
  'hapticDevice',
]);

export type TeleopMode = zod.infer<typeof TeleopModeEnum>;

export default zod.object({
  mode: TeleopModeEnum.default('iosTablet'),
  timeoutSeconds: zod.number().int().positive().default(300),
  tags: zod.array(zod.string().max(30)).default([]),
  gripperVelocity: zod.number().positive().optional(),
  gripperMin: zod.number().min(0).max(1).optional(),
  gripperMax: zod.number().min(0).max(1).optional(),
});
